<style lang="less" scoped>
	.editable {
		cursor: pointer;
	}


	.columnToolbar{
	}

</style>

<template>
	<v-hover v-slot:default="{ hover }" close-delay="100" open-delay="100">
		<v-col style="position: relative" v-bind:class="classes" :cols="element.attrs.cols" :xs="element.attrs.xs" :sm="element.attrs.sm" :md="element.attrs.md" :lg="element.attrs.lg" :id="element.id" :style="style">
			<v-btn fab x-small absolute top right v-if="hover && focus !== element" @click="$emit('focus', element)" class="focusButton">
				<v-icon x-small color="grey">mdi-cursor-default</v-icon>
			</v-btn>
			<v-btn fab x-small absolute top right v-if="focus == element" @click="$emit('focus', false)" class="focusButton">
				<v-icon x-small color="grey">mdi-close</v-icon>
			</v-btn>
			<div v-if="focus == element" style="height: 50px"></div>
			<EditorElement v-for="childElement in element.elements" :key="childElement.id" :element="childElement" :focus="focus" v-on:delete="deleteElem( childElement, element)" v-on:focus="(f) => { $emit('focus', f)}"></EditorElement>
			<EditorToolbar class="columnToolbar" v-if="focus == element" :element="element" :focus="editing"  v-on:delete="$emit('delete', element)" ></EditorToolbar>	
		</v-col>
	</v-hover>
</template>


<script type="text/javascript">
	import EditorToolbar from "../TextEditor/EditorToolbar.vue"
	export default {
		name: "EditorColumn",
		props: {
			focus: {type: Object },
			element: {type: Object}
		},
		data: () =>{
			return {
				text: "Text",
			}
		}, 
		computed:{
			classes(){
				var object = {}
				object.bordered = true;
				object[this.element.attrs.padding] = this.element.attrs.padding ? true : false;
				object[this.element.attrs.margin] = this.element.attrs.margin ? true : false;
				return object;
			}, 
			style(){
				var styles = {}
				var imgUrl = this.element.attrs.imgUrl; 
				if( imgUrl ){
					styles['background-image'] = "url('" + imgUrl + "')";
					styles['background-size'] = "cover";
					styles['height'] = this.element.attrs.height;
				}
				return styles;
			},
		},
		components: {
			EditorElement: () => import("../TextEditor/EditorElement"),
			EditorToolbar: EditorToolbar
		},
		methods: {
			deleteElem(child, element ){
				element.elements.splice( element.elements.indexOf(child), 1 )
				this.$emit('focus', element)
			}
		}

	}	
</script>